export default "__VITE_ASSET__Tu9d$uOd__"